/**
 * @generated SignedSource<<d3772932d931dbce0a059c215011830a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Salutation = "Divers" | "Mr" | "Mrs" | "Unknown" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserDescription_UserFragment$data = {
  readonly extension: {
    readonly firstName?: string | null | undefined;
    readonly lastName?: string | null | undefined;
    readonly salutation?: Salutation | null | undefined;
    readonly title?: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "UserDescription_UserFragment";
};
export type UserDescription_UserFragment$key = {
  readonly " $data"?: UserDescription_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserDescription_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserDescription_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "InfectopharmUserExtension"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salutation",
              "storageKey": null
            }
          ],
          "type": "InfectopharmUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e9aeebc9c0546ebcc67018951301fe01";

export default node;
